import styled from 'styled-components';

export const Track = styled.div`
  overflow: hidden;
  width: 100%;
  height: 8px;
  border-radius: 999px;
  background: ${({ theme }) => theme.colors.background.extraLight};
`;

export const Fill = styled.div<{ $percentage: number }>`
  width: ${({ $percentage }) => $percentage}%;
  height: 100%;
  border-radius: 999px;
  background: ${({ theme }) => theme.colors.teal};
  transition: width 0.4s ease;
`;
